import { useState } from 'react';

import { Flex, Box, Text, CloseButton } from '@chakra-ui/react';

import style from './HomeAlertMessage.style';

export interface HomeAlertMessageProps {
  message: string;
  variant?: 'info' | 'warning' | 'error' | 'success';
  onClose?: () => void;
}

const HomeAlertMessage = ({
  message,
  variant,
  onClose,
}: HomeAlertMessageProps) => {
  const [isVisible, setIsVisible] = useState(true);

  const handleClose = () => {
    setIsVisible(false);
    onClose?.();
  };

  if (!isVisible) return null;

  return (
    <Box
      sx={style.container}
      data-variant={variant}
      className="app-alertmessage"
    >
      <Flex sx={style.content}>
        <Text sx={style.message}>{message}</Text>
        <CloseButton
          onClick={handleClose}
          sx={style.closeButton}
          aria-label="Close alert"
        />
      </Flex>
    </Box>
  );
};

export default HomeAlertMessage;
